import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { JsonPipe } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { ImpactAssessmentDetailsDD } from 'src/app/core/models/impact-assessment/impact-assessment-details-dd';
import { ImpactAssessmentDropDownList } from 'src/app/core/models/impact-assessment/impact-assessment-dropdown-list-model';
import { ImpactAssessment4 } from 'src/app/core/models/impact-assessment/impact-assessment4';
import { ImpactAssessmentT4DetailsDD } from 'src/app/core/models/impact-assessment/impact-assessmentT4-details-dd';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { UserProfile } from 'src/app/core/models/user';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { MasterHelper } from 'src/app/core/utilities';
// import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';

@Component({
  selector: 'app-bulk-update-t4-dialog',
  templateUrl: './bulk-update-t4-dialog.component.html',
  styleUrls: ['./bulk-update-t4-dialog.component.scss']
})
export class BulkUpdateT4DialogComponent {
  toastModel: ToastViewModel;
  isToastShow = false;
  templateNo: number = 0;
  impactAssessment: ImpactAssessment4;
  impactAssessmentDD: ImpactAssessmentT4DetailsDD;
  userAccessToken: UserProfile;
  alertDialogModel: AlertDialogModel;
  jurisdictions: JurisdictionsList = new JurisdictionsList;
  searchedJurisdiction: any[] = [];
  isLoadingDD = false;
  searchedAssessor: FilterViewModel[] = [];
  allSearchedAssessor: FilterViewModel[] = [];
  searchedJuris: ItemIdModel[] = [];
  selectedJuris: ItemIdModel[] = [];
  searchAssessorCntrl: FormControl = new FormControl();
  assessorDD: string[] = [];
  assessmentStatus: Array<string> = [];
  dropdownData: Expertise[] = [];
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;
  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  searchStr = '';
  isADetailPermission = true;
  isIADetails1 = false;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  // public Editor = customBuild;

  constructor(
    private impactService: ImpactService, private jsonPipe: JsonPipe, public dialog: MatDialog,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<BulkUpdateT4DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public templateno: any,
    public sanitizer: DomSanitizer,
  ) {
    this.templateNo = this.templateno;
    this.toastModel = new ToastViewModel();
    this.impactAssessment = new ImpactAssessment4();
    this.impactAssessmentDD = new ImpactAssessmentT4DetailsDD();
    this.userAccessToken = new UserProfile();
    // this.getImpactAssesmentDropdownList('');
    this.alertDialogModel = new AlertDialogModel();
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.fetchJurisdiction();
    this.fetchImpactAssessmentDD();
  }

  getImpactAssesmentDropdownList(jurisdiction: string): void {
    this.impactService.getImpactAssesmentDropDownList(jurisdiction).subscribe((result: ImpactAssessmentDropDownList) => {
      result.currentStatus.forEach(element => {
        this.assessmentStatus.push(element.title)
      });
       result.dropdownForTemp4.forEach(element => {
         this.dropdownData.push(element)
       });
    });
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
    });
  }

  fetchJurisdiction(): void {
    this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
      this.jurisdictions = result;

      this.searchedJurisdiction = this.jurisdictions.jurisdictions;
    })
  }

  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentT4DD().subscribe((result: ImpactAssessmentT4DetailsDD) => {
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      this.selectedDDvalue();
    });
  }

  ddListData(): void {
    this.searchedAssessor = this.impactAssessmentDD.assessor;
    this.allSearchedAssessor = this.impactAssessmentDD.assessor;
    this.searchedJuris = this.impactAssessmentDD.jurisdiction;

    this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAssessor = term ? this.filterAssessor(term) : this.impactAssessmentDD.assessor;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
  }

  filterAssessor(search: string): any {
    return this.searchedAssessor.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  filterJurisdiction(search: string): any {
    return this.searchedJurisdiction.filter(option =>
      option.title.toLowerCase().includes(search.toLowerCase())
    );
  }

  selectedDDvalue(): void {
    this.assessorDD = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    let selectedJurisName = localStorage.getItem('selectedDivisionName');
    this.selectedJuris.push({ id: 0, name: selectedJurisName! });
    this.getImpactAssesmentDropdownList(selectedJurisName!);
    this.impactAssessment.jurisdiction = selectedJurisName!;
    // if (this.impactAssessment.jurisdiction) {
    //   this.impactAssessment.jurisdiction.split(',').forEach(juris => {
    //     this.selectedJuris.push({ id: 0, name: juris });
    //   });
    // }
  }

  onSelectJuris(event: any) {
    this.getImpactAssesmentDropdownList(event.name);
    this.impactAssessment.jurisdiction = event.name;
  }

  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }

  addAssessor(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.assessorAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    if (this.assessorInput) {
      this.assessorInput.nativeElement.value = '';
    }
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
    }
  }

  getFilteredData(filter: string, event: any): void {
    this.searchStr += event.key;
    switch (filter) {
      case 'Assessor':
        const searchedA = Array<FilterViewModel>();
        if (this.searchedAssessor.length > 0) {
          this.searchedAssessor.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedA.push(element);
            }
          });
          this.searchedAssessor = searchedA;
        } else {
          this.searchedAssessor = this.allSearchedAssessor;
        }
        break;
    }
    this.searchStr = '';
  }

  updateImpactAssessment(): void {
    this.impactAssessment.templateNo = this.templateNo;
    this.impactAssessment.assessor = this.assessorDD.toString();
   
    this.impactAssessment.applicationDate = this.impactAssessment
      .applicationDate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.applicationDate.toString()
      )
      : null;
    this.impactAssessment.lastUpdate = this.impactAssessment
      .lastUpdate
      ? MasterHelper.bsdatePickerToCorrectDate(
        this.impactAssessment.lastUpdate.toString()
      )
      : null;
    this.impactAssessment.userId = this.userAccessToken.externalUserId;
    this.impactAssessment.userName = this.userAccessToken.fullName;
    this.dialogRef.close(this.impactAssessment);
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

export class Expertise {
  name!: string;
  color!: string;
}
